module.exports = __webpack_public_path__ + "media/delivering-trust.be3e8abe.mp4";